export function accordions () {
  const accordionTitles = document.querySelectorAll('.accordion--title')
  const accordionContent = document.querySelectorAll('.accordion--content')

  accordionTitles.forEach((accordionTitle, index) => {
    accordionTitle.addEventListener('click', (e) => {
      const el = e.currentTarget
      if (el.parentElement.classList.contains('open')) {
        el.parentElement.classList.remove('open')
      } else {
        accordionContent.forEach((accordion) => {
          if (accordion.classList.contains('open')) {
            accordion.classList.remove('open')
          }
        })
        el.parentElement.classList.add('open')
      }
    })
  })
}

export function accordionTabs () {
  const accordionHeader = document.querySelectorAll('.accordion--header')
  const accordionItems = document.querySelectorAll('.accordion--item')

  accordionHeader.forEach((accordion) => {
    accordion.addEventListener('keyup', e => {
      if (e.keyCode === 9) {
        accordionsOpenClose(accordionItems, e)
      }
    })
    accordion.addEventListener('click', e => {
      // scrollTo(accordion)
      accordionsOpenClose(accordionItems, e)
    })
  })
}

function accordionsOpenClose (accordions, target) {
  const el = target.currentTarget
  if (el.parentElement.classList.contains('open')) {
    el.parentElement.classList.remove('open')
  } else {
    el.parentElement.classList.add('open')
  }
}

// Tabs initialize function
export function tabsInit () {
  // Get all tab elements
  const tabs = document.querySelectorAll('.tab-link')
  // Get the current active tab
  let activeNav = document.querySelector('.tab-link.active')
  let activeTab = document.querySelector('.tab-pane.active')

  // Click listener for each tab
  tabs.forEach((tab) => {
    tab.addEventListener('click', event => {
      event.preventDefault()
      // Get the target tab ID from the href
      const targetTabId = tab.getAttribute('href')
      // Find the target content
      const targetTab = document.querySelector(targetTabId)
      // Show the target content
      activeNav.classList.remove('active')
      activeTab.classList.remove('active')
      tab.classList.add('active')
      targetTab.classList.add('active')
      // Update the active tab variable
      activeNav = tab
      activeTab = targetTab
    })
  })

  accordionTabs()
}

export function toTimestamp (date) {
  date -= date % (24 * 60 * 60 * 1000)
  date += new Date().getTimezoneOffset() * 60 * 1000
  date = date / 1000

  return date
}

export function smoothScroll (target) {
  let scrollContainer = target
  do { // find scroll container
    scrollContainer = scrollContainer.parentNode
    if (!scrollContainer) return
    scrollContainer.scrollTop += 1
  } while (scrollContainer.scrollTop == 0)

  let targetY = 0
  do { // find the top of target relatively to the container
    if (target == scrollContainer) break
    targetY += target.offsetTop
  } while (target == target.offsetParent)

  const scroll = function (c, a, b, i) {
    i++
    if (i > 30) return
    c.scrollTop = a + (b - a) / 30 * i
    setTimeout(function () {
      scroll(c, a, b, i)
    }, 20)
  }
  // start scrolling
  scroll(scrollContainer, scrollContainer.scrollTop, targetY - 150, 0)
}

export function getTemplate (templateName) {
  return document.querySelector('#' + templateName + '-template').innerHTML
}

export function getQueryParameterValue (param) {
  const urlString = window.location.href
  const url = new URL(urlString)

  return url.searchParams.get(param)
}

export function setDateFormat (dateString) {
  const newDate = new Date(dateString)
  let shopLocale = 'en'
  if (window.theme.settings.shopLocale) shopLocale = window.theme.settings.shopLocale

  if (shopLocale !== 'en') return newDate.toLocaleDateString()

  dateString = dateString.toDateString().split(' ')

  if (!dateString[1] && !dateString[2] && !dateString[3]) return

  return `${getOrdinalNum(dateString[2].replace(/^0+/, ''))} ${monthNames[newDate.getMonth()]} ${dateString[3]}`
}

const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
]

const getOrdinalNum = (number) => {
  let selector

  if (number <= 0) {
    selector = 4
  } else if ((number > 3 && number < 21) || number % 10 > 3) {
    selector = 0
  } else {
    selector = number % 10
  }

  return number + ['th', 'st', 'nd', 'rd', ''][selector]
}

export function hideButton (buttonElement) {
  buttonElement.classList.add('is-hidden')
}

export function showButton (buttonElement) {
  buttonElement.classList.remove('is-hidden')
}

export function loadImage (imgSrc) {
  return new Promise((resolve, reject) => {
    const Img = new Image()
    Img.src = imgSrc
    resolve(Img)
  })
}

export function mountAppStoreButton (retailers) {
  const appStoreButtonWrapper = document.querySelector('.js-app-store-buttons-wrapper')
  const appStoreButtonText = document.querySelector('.js-app-store-buttons-text')

  const appleAppStoreObject = retailers.find(retailer => {
    if (retailer.path && typeof retailer.path === 'string') {
      return retailer.path.search('apps.apple.com') > -1
    }
  })

  if (appleAppStoreObject && typeof appleAppStoreObject.path === 'string' && appStoreButtonWrapper) {
    const appleAppStoreButton = `<a href="${appleAppStoreObject.path}" title="Apple Store Logo" class="supadu-app-store-buttons__badges" target="_blank"></a>`
    appStoreButtonWrapper.insertAdjacentHTML('beforeend', appleAppStoreButton)

    if (appStoreButtonText) {
      appStoreButtonText.classList.remove('is-hidden')
    }
  }
}

// M&B Subscription Details
export function getSubscriptionDetails (collectionName) {
  return fetch('/collections/' + collectionName + '/products.json').then(resp => resp.json()).then((subscription) => {
    let content = ''
    let price = ''
    let handleURL = ''
    if (subscription.products && subscription.products.length) {
      content += `<div class="subscription__type"><div class="subscription__choice"><label for="subscription__${collectionName}">Choose your type:</label><select name="subscription__${collectionName}" id="subscription__${collectionName}">`
      subscription.products.forEach((product, index) => {
        if (index === 0 && product.variants && product.variants.length) {
          price = product.variants[0].price
          handleURL = product.handle
        }
        if (product.title.includes('-')) {
          product.title = product.title.split('-')[1].trim()
        }
        content += `<option value="${product.handle}" data-price="${product.variants[0].price}" data-handle="${product.handle}">${product.title}</option>`
      })
      content += '</select></div></div>'
      if (price) {
        content += `<p class="subscription__price">$<span>${price}</span></p>`
      }
      if (handleURL) {
        content += `<a href="/products/${handleURL}" class="subscription__buy btn">Add to Cart</a>`
      }
      content += '<svg aria-hidden="true" focusable="false" class="icon icon-close" viewBox="0 0 64 64"><path d="M19 17.61l27.12 27.13m0-27.12L19 44.74"></path></svg>'
    }
    return content
  })
}

export function subscriptionTileContent (item, data, collectionName) {
  const subscriptionDetails = item.querySelector('.subscription-details')
  subscriptionDetails.insertAdjacentHTML('beforeend', '<div class="subscription-details__inner">' + data + '</div>')
  document.getElementById('subscription__' + collectionName + '').addEventListener('change', (evt) => {
    const selected = evt.target.options[evt.target.selectedIndex]
    item.querySelector('.subscription__price span').innerHTML = selected.dataset.price
    item.querySelector('.subscription__buy').setAttribute('href', '/products/' + selected.dataset.handle + '/')
  })
  item.addEventListener('click', (e) => {
    e.preventDefault()
    subscriptionDetails.style.display = 'flex'
  })
  subscriptionDetails.querySelector('.icon-close').addEventListener('click', (e) => {
    e.preventDefault()
    e.stopPropagation()
    subscriptionDetails.style.display = 'none'
  })
  subscriptionDetails.querySelector('.subscription__buy').addEventListener('click', (e) => {
    e.stopPropagation()
  })
}

/**
 * Get the current format from a book format array using the ISBN
 * @param {String} isbn
 * @param {Array} formatArray
 */
export function getFormat (isbn, formatArray) {
  const filteredArray = Array.isArray(formatArray) ? formatArray.filter(format => format.isbn === isbn) : []
  if (!filteredArray.length) {
    return
  }
  return filteredArray[0]
}

/**
 * Mills & Boon retailer dropdown options
 */
export const mandbRetailers = {
  eBook: [{
    name: 'Amazon AU',
    url: 'https://www.amazon.com.au/s/ref=nb_sb_noss?url=search-alias%3Daps&field-keywords={isbn}'
  }, {
    name: 'Apple Books',
    url: 'https://itunes.apple.com/au/book/isbn{isbn}?at=10l7rh&ct=millsandboonproductpage'
  }, {
    name: 'Kobo',
    url: 'http://ads.harpercollins.com.au/hc?isbn={isbn}&retailer=kobo'
  }, {
    name: 'Google Play',
    url: 'http://ads.harpercollins.com.au/hc?isbn={isbn}&retailer=googleplay&locale=au'
  }],
  default: [{
    name: 'The Nile',
    url: 'http://ads.harpercollins.com/thenile?isbn={isbn}&retailer=nile&locale=au'
  }, {
    name: 'Boomerang Books',
    url: 'http://www.boomerangbooks.com.au/a/b/book_{isbn}.htm?utm_source=millsandboon&utm_medium=aff&utm_campaign=deeplink'
  }, {
    name: 'Amazon AU',
    url: 'https://www.amazon.com.au/s?k={isbn}&camp=247&creative=1211&linkCode=ur2&linkId=f7799f54a3cec7f970478efb57d8a04b&tag=hcpanz-22&ref=as_li_qf_sp_sr_tl'
  }]
}

export function formatVitalsourceLinks (e) {
  if (!e) return null
  const link = e.currentTarget
  if (!link || !link.href) return null
  const url = new URL(link.href)
  const timestamp = Math.floor(Date.now() / 1000)
  url.searchParams.set('s', timestamp)
  return url.toString()
}

export function elementReady (selector) {
  return new Promise((resolve) => {
    const el = document.querySelector(selector)
    if (el) { resolve(el) }
    new MutationObserver((mutationRecords, observer) => {
      // Query for elements matching the specified selector
      Array.from(document.querySelectorAll(selector)).forEach((element) => {
        resolve(element)
        observer.disconnect()
      })
    })
      .observe(document.documentElement, {
        childList: true,
        subtree: true
      })
  })
}

export function tooltip (text) {
  if (!text) {
    return ''
  }
  return `<span 
            class="tooltip">
            <span class="tooltip-text">
              ${text}
            </span>
            <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M0 10C0 4.478 4.478 0 10 0c5.523 0 10 4.478 10 10 0 5.523-4.477 10-10 10-5.522 0-10-4.477-10-10zm11.125 2.002H8.989v-.141c.01-1.966.492-2.254 1.374-2.782.093-.056.19-.114.293-.178.73-.459 1.292-1.038 1.292-1.883 0-.948-.743-1.564-1.666-1.564-.851 0-1.657.398-1.712 1.533H6.304C6.364 4.693 8.18 3.5 10.294 3.5c2.306 0 3.894 1.447 3.894 3.488 0 1.382-.695 2.288-1.805 2.952l-.238.144c-.79.475-1.009.607-1.02 1.777V12zm.17 3.012a1.344 1.344 0 01-1.327 1.328 1.32 1.32 0 01-1.328-1.328 1.318 1.318 0 011.328-1.316c.712 0 1.322.592 1.328 1.316z" fill="#5C5F62"/></svg></span>`
}
export function addScript (url, attrs) {
  /**
   * @param url URL for the script tag src attribute
   * @param attrs Other attributes for the script tag - passed as key value object
   */
  // get the last element on the page
  const lastNode = document.body.lastChild
  // create a script element
  const script = document.createElement('script')

  // loop the passed in attributes
  for (const key in attrs) {
    if (!attrs.hasOwnProperty(key)) {
      continue
    }

    // set the attribute name to the key in the object
    // and the value to the value in the object
    script.setAttribute(key, attrs[key])
  }

  // set the src value of the script tag
  script.setAttribute('src', url)

  // insert the tag after the last element on the page
  lastNode.parentNode.insertBefore(script, lastNode.nextSibling)
}

export function isMobile () {
  // device detection
  if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) ||
    /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
    return true
  }
  return false
}

export function showErrorMessage (productContainer, loader) {
  loader.style.display = 'none'
  productContainer.style.display = 'block'
  productContainer.innerHTML = '<section class="shopify-section page-width"><h2 class="product-title">Data not available for this ISBN13.</h2></section>' + productContainer.innerHTML
}

export function productTranslations () {
  if (!window.theme.strings.languagesLabel) {
    return ''
  }
  const productStrings = window.theme.strings.languagesLabel.replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/=&gt;/g, ':')
  if (!IsJsonString(productStrings)) {
    return ''
  }

  return JSON.parse(productStrings)
}

export function generalTranslations () {
  if (!window.theme.strings.generalTranslations) {
    return ''
  }
  const productStrings = window.theme.strings.generalTranslations.replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/=&gt;/g, ':')
  if (!IsJsonString(productStrings)) {
    return ''
  }

  return JSON.parse(productStrings)
}

export function collectionsTranslations () {
  if (!window.theme.strings.collectionsTranslations) {
    return ''
  }
  const productStrings = window.theme.strings.collectionsTranslations.replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/=&gt;/g, ':')
  if (!IsJsonString(productStrings)) {
    return ''
  }

  return JSON.parse(productStrings)
}

export function IsJsonString (str) {
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}
